// extracted by mini-css-extract-plugin
export default {"securityCopy":"AddBankDetailsFormButtons__securityCopy-w7N7"};